/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { TextField, Box, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { useQuery, useMutation } from '@apollo/client';
import { ExpandMore, WidgetsOutlined } from '@material-ui/icons/';
import { GET_PRODUCT_BY_ID, EDIT_PRODUCT } from '../../queries/products/product';
import useStyles from './styles';

const Product = ({ productId, brandId, save }) => {
  const [name, setName] = useState('');
  const [hotsite, setHotsite] = useState('');
  const [appURL, setAppURL] = useState('');
  const [TOSLink, setTosLink] = useState('');

  const [readOnlyHotsite, setReadOnlyHotsite] = useState(false);
  const [readOnlyAppURL, setReadOnlyAppURL] = useState(false);
  const [readOnlyTosLink, setReadOnlyTosLink] = useState(false);

  const classes = useStyles();

  const [updateBrand] = useMutation(EDIT_PRODUCT);

  const handleChange = (set, event) => {
    if (event.target.value || event.target.value === '' || event.target.value === 0) {
      set(event.target.value);
    }
  };

  const queryProduct = useQuery(GET_PRODUCT_BY_ID, {
    variables: {
      id: productId,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (save) {
      updateBrand({
        variables: {
          id: productId,
          brandId,
          name,
          hotsite,
          appURL,
          TOSLink,
        },
      });
    }
  }, [save, updateBrand]);

  useEffect(() => {
    if (queryProduct && queryProduct.data) {
      const { data: { product: { name, hotsite, appURL, TOSLink } } } = queryProduct;
      setName(name);
      setHotsite(hotsite);
      setAppURL(appURL);
      setTosLink(TOSLink);

      hotsite && setReadOnlyHotsite(true);
      appURL && setReadOnlyAppURL(true);
      TOSLink && setReadOnlyTosLink(true);
    }
  }, [queryProduct]);

  if (!name) return (<></>);

  return (
    <Box mt={2}>
      <Accordion elevation={3}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="brand-accordion-content"
          id="brand-accordion-header"
        >
          <Box className={classes.headerAccordion}>
            <WidgetsOutlined />
            {`Product ‣ ${name}`}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <TextField
              id="hotsite"
              label="Hotsite"
              value={hotsite}
              className={classes.textField}
              onChange={(e) => handleChange(setHotsite, e)}
              InputProps={{
                readOnly: readOnlyHotsite,
              }}
              required
            />
            <TextField
              id="appurl"
              label="App URL"
              value={appURL}
              className={classes.textField}
              onChange={(e) => handleChange(setAppURL, e)}
              InputProps={{
                readOnly: readOnlyAppURL,
              }}
              required
            />
            <TextField
              id="TOSlink"
              label="TOS Link"
              value={TOSLink}
              className={classes.textField}
              onChange={(e) => handleChange(setTosLink, e)}
              InputProps={{
                readOnly: readOnlyTosLink,
              }}
              required
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default React.memo(Product);
